import l10n from '../i18n/I18N'
import { formatCurrencyAmount, getThemeImageUrl } from '../../services/utils'
import { config } from '../Init/Init'
import { useCryptoPackageModal } from './CryptoPackageModalProvider'
import { useCryptoPaymentModal } from '../CryptoPaymentModal'
import { useCasinoStore } from '../../services/store'

import classes from './styles/cryptoPackageModalItem.module.scss'

export const CryptoPackageModalItem = ({ item }) => {
  const casinoStore = useCasinoStore()
  const casinoCoinsToFiatRate = casinoStore.use.casinoCoinsToFiatRate()

  const { handleCloseCryptoPackageModal } = useCryptoPackageModal()
  const { handleOpenCryptoPaymentDepositModal } = useCryptoPaymentModal()

  return (
    <div>
      <div className={classes.cryptoPackageModalItem}>
        <img
          src={getThemeImageUrl(classes.cryptoPaymentGameIcon)}
          className={classes.cryptoPackageModalItem_image}
          alt={l10n.t['cryptopackage.bundleI.lbvGameIconAlt']}
        />
        {casinoCoinsToFiatRate.toCoins.GC && (
          <div className={classes.cryptoPackageModalItem_gcAmount}>
            {l10n.t['currency.GC']}&nbsp;{formatCurrencyAmount(item.usdAmount * casinoCoinsToFiatRate.toCoins.GC, 'GC')}
          </div>
        )}

        <div className={classes.cryptoPackageModalItem_freeOffer}>
          <div className={classes.cryptoPackageModalItem_freeOfferLabel}>{l10n.t['cryptopackage.bundleI.offer']}</div>
          <div className={classes.cryptoPackageModalItem_freeOfferCoins}>
            <img
              src={getThemeImageUrl(classes.cryptoPaymentSweepsIcon)}
              alt={l10n.t['currency.SC']}
              className={classes.cryptoPackageModalItem__coinIcon}
            />
            {casinoCoinsToFiatRate.toCoins.SWC && (
              <div className={classes.cryptoPackageModalItem_freeOfferAmount}>
                {l10n.t['currency.SC']}&nbsp;
                {formatCurrencyAmount(item.usdAmount * casinoCoinsToFiatRate.toCoins.SWC, 'SC')}
              </div>
            )}
          </div>
        </div>
      </div>
      <button
        className={classes.cryptoPackageModalItem_button}
        onClick={() => {
          handleCloseCryptoPackageModal()
          handleOpenCryptoPaymentDepositModal(item.usdAmount)
        }}
      >
        {config.currencySymbolMap.USD}&nbsp;
        {formatCurrencyAmount(item.usdAmount, config.baseFiatCurrency)}
      </button>
    </div>
  )
}
